import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import { Encabezado } from './Encabezado';

class Blog extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Blog">
                    <section className="paginaItmex">
                        <Encabezado etiqueta="Blog" titulo="Blog" />
                        <div className="paginaItmex-vacio">
                            <span className="beneficiosPaso-icono"><i className="fas fa-pen-nib"></i></span>
                            <h2>Todavía no publicamos contenido. ¡Espéralo pronto!</h2>
                            <p>Mientras tanto, escucha nuestros podcasts con historias de la comunidad.</p>
                            <Link className="heroItmex-cta paginaItmex-cta-oscuro" to="/podcasts">
                                Ir a podcasts
                                <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                            </Link>
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Blog;
